import { render, staticRenderFns } from "./unused--comp_ProductPageCustomizationInputs-astralito-adultos.vue?vue&type=template&id=ebb04562&"
import script from "./unused--comp_ProductPageCustomizationInputs-astralito-adultos.vue?vue&type=script&lang=js&"
export * from "./unused--comp_ProductPageCustomizationInputs-astralito-adultos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
